export const LOCAL_LOGIN = "http://localhost:5000/login";
export const LOGIN = "https://mindandcode.com/login";
export const EMAIL = window.atob("YnJvd24ua2VlZ2FuQGdtYWlsLmNvbQ==");
